<template>
  <CModal
      :centered="true"
      :close-on-backdrop="false"
      :show.sync="modalStatus.status"
      :title="modalStatus.title"
      color="danger"
  >
    <div class="p-1 pl-0">
      {{ modalStatus.text }}
    </div>
    <template #footer-wrapper>
      <CRow class="p-2">
        <CCol class="text-right">
          <CButton @click="confirm(false)" class="mr-2" color="light">Cancel</CButton>
          <CButton @click="confirm(true)" color="danger">Confirm</CButton>
        </CCol>
      </CRow>
    </template>
  </CModal>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  name: "ConfirmActionModal",
  methods: {
    confirm(type) {
      if (type) {
        this.$emit("confirm", true)
      } else {
        this.$store.commit("modal/onSetConfirmActionModalStatus", {status: false})
      }
    },
  },
  computed: {
    ...mapGetters({
      modalStatus: "modal/confirmActionModalStatus"
    })
  },
  watch: {
    "modalStatus.status"(value) {
      if (!value) {
        this.$emit("confirm", false)
      }
    }
  }
}
</script>
